import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ParticlesBackground from "./ParticlesBackground";
import "./Home.css";

const Home = () => {

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const { t } = useTranslation();
  const [showParticles, setShowParticles] = useState(window.innerWidth >= 1450);

  useEffect(() => {

    const handleThemeChange = () => {
      setTheme(localStorage.getItem("theme") || "light");
    };

    const handleResize = () => {
      setShowParticles(window.innerWidth >= 1350);
    };

    window.addEventListener("themeChanged", handleThemeChange);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
      window.removeEventListener("resize", handleResize);
    };

  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("day-mode", theme === "light");
    document.documentElement.classList.toggle("dark-mode", theme === "dark");
  }, [theme]);

  return (
    <>
      {showParticles && <ParticlesBackground theme={theme} />}

      <Container fluid className="home-main-container">

        <Row className="home-main-row">

          {/* NOM */}
          <Col xs={12} xl={3} className="home-col-name">

            <div className="name-container">

              <div className="first-name">
                <span className="initials">R</span>
                <span className="arial">eda</span>
              </div>

              <div className="last-name">
                <span className="initials">M</span>
                <span className="arial">dair</span>
              </div>

              <div className="subtitle">Data Science</div>

            </div>

          </Col>


          {/* ABOUT */}
          <Col xs={12} xl={9} className="home-col-about">


            <h1 className="welcome-title">
              <span className="turquoise">{t("welcome")}</span>
            </h1>

                                    <div className="spacer-small"></div> {/* ← espace sous Welcome */}

            <div className="home-about-body">

              <span style={{ color: theme === "light" ? "black" : "white" }}>
                {t("intro")}
              </span>

                  <div className="spacer-small2"></div> {/* ← nouvel espace sous Intro */}

              <div className="expertise-list">

                {[1,2,3].map(num => (

                  <div key={num} className="expertise-item">

                    <div
                      className="bullet-point"
                      style={{
                        background: theme === "light"
                          ? "linear-gradient(135deg,#6d4b35,#a67c52)"
                          : "linear-gradient(135deg,#40e0d0,#afeeee)",
                        boxShadow: theme === "light"
                          ? "0 1px 3px rgba(109,75,53,0.3)"
                          : "0 0 5px rgba(175,238,238,0.5)"
                      }}
                    />

                    <span className="highlighted-text"
                      style={{ color: theme === "light" ? "black" : "white" }}>
                      {t(`expertise${num}`)}
                    </span>

                    <span className="expertise-desc"
                      style={{ color: theme === "light" ? "black" : "white" }}>
                      {" "}{t(`expertise${num}_desc`)}
                    </span>

                  </div>

                ))}

              </div>

            </div>

          </Col>

        </Row>

      </Container>
    </>
  );
};

export default Home;